/**
 * Add readmore/showless functionality to Clinical Trials.
 *
 * @package Embark
 * @since   1.0.0
 */

import $ from 'jquery';

function wordCount(text = '') {
	return text.split(/\S+/).length - 1;
}

function addReadMore() {
	const readmore = document.querySelectorAll('.read-more');

	readmore.forEach((e) => {
		console.log(e);
		let test = 0;
		test = wordCount(e.textContent);
		console.log(test);
		if (test >= 50) {
			e.classList.remove('hidden');
			e.nextElementSibling.classList.remove('hidden');
		}
	});
}

window.addEventListener('load', addReadMore);
$(document).on('click', '.btn-more', (e) => {
	const expanded = $(e.target).hasClass('expand');

	// close all open paragraphs
	$('.btn-more.expand').text('Show More');
	$('.read-more.expand').removeClass('expand');
	$('.btn-more.expand').removeClass('expand');

	// if target wasn't expand, then expand it
	if (!expanded) {
		$(e.target).prev('.read-more').addClass('expand');
		$(e.target).addClass('expand');
		$('.btn-more.expand').text('Show Less');
	}
});
